import { render, staticRenderFns } from "./NText.vue?vue&type=template&id=10d0c446&"
import script from "./NText.vue?vue&type=script&lang=js&"
export * from "./NText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports